var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWandb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.91278e-05 32.3C-5.91278e-05 38.0084 4.62746 42.6359 10.3358 42.6359C16.0441 42.6359 20.6716 38.0084 20.6716 32.3C20.6716 26.5917 16.0441 21.9642 10.3358 21.9642C4.62746 21.9642 -5.91278e-05 26.5917 -5.91278e-05 32.3Z",
    fill: "#FFCC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.91278e-05 83.9792C-5.91278e-05 89.6875 4.62746 94.3151 10.3358 94.3151C16.0441 94.3151 20.6716 89.6875 20.6716 83.9792C20.6716 78.2709 16.0441 73.6434 10.3358 73.6434C4.62746 73.6434 -5.91278e-05 78.2709 -5.91278e-05 83.9792Z",
    fill: "#FFCC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87589 58.1402C3.87589 61.7079 6.76813 64.6002 10.3359 64.6002C13.9037 64.6002 16.7959 61.7079 16.7959 58.1402C16.7959 54.5724 13.9037 51.6802 10.3359 51.6802C6.76813 51.6802 3.87589 54.5724 3.87589 58.1402Z",
    fill: "#FFCC33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87589 6.46001C3.87589 10.0278 6.76813 12.92 10.3359 12.92C13.9037 12.92 16.7959 10.0278 16.7959 6.46001C16.7959 2.89224 13.9037 0 10.3359 0C6.76813 0 3.87589 2.89224 3.87589 6.46001Z",
    fill: "#FFCC33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.664 67.7001C39.664 73.4084 44.2915 78.0359 49.9998 78.0359C55.7082 78.0359 60.3357 73.4084 60.3357 67.7001C60.3357 61.9918 55.7082 57.3643 49.9998 57.3643C44.2915 57.3643 39.664 61.9918 39.664 67.7001Z",
    fill: "#FFCC33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5399 93.5402C43.5399 97.108 46.4322 100 50 100C53.5677 100 56.46 97.108 56.46 93.5402C56.46 89.9724 53.5677 87.0802 50 87.0802C46.4322 87.0802 43.5399 89.9724 43.5399 93.5402Z",
    fill: "#FFCC33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5399 41.8609C43.5399 45.4286 46.4322 48.3209 50 48.3209C53.5677 48.3209 56.46 45.4286 56.46 41.8609C56.46 38.2931 53.5677 35.4008 50 35.4008C46.4322 35.4008 43.5399 38.2931 43.5399 41.8609Z",
    fill: "#FFCC33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5399 16.0208C43.5399 19.5886 46.4322 22.4808 50 22.4808C53.5677 22.4808 56.46 19.5886 56.46 16.0208C56.46 12.453 53.5677 9.56079 50 9.56079C46.4322 9.56079 43.5399 12.453 43.5399 16.0208Z",
    fill: "#FFCC33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3283 32.3C79.3283 38.0084 83.9558 42.6359 89.6642 42.6359C95.3725 42.6359 100 38.0084 100 32.3C100 26.5917 95.3725 21.9642 89.6642 21.9642C83.9558 21.9642 79.3283 26.5917 79.3283 32.3Z",
    fill: "#FFCC33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2043 6.46001C83.2043 10.0278 86.0965 12.92 89.6643 12.92C93.232 12.92 96.1243 10.0278 96.1243 6.46001C96.1243 2.89224 93.232 0 89.6643 0C86.0965 0 83.2043 2.89224 83.2043 6.46001Z",
    fill: "#FFCC33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2043 58.1402C83.2043 61.7079 86.0965 64.6002 89.6643 64.6002C93.232 64.6002 96.1243 61.7079 96.1243 58.1402C96.1243 54.5724 93.232 51.6802 89.6643 51.6802C86.0965 51.6802 83.2043 54.5724 83.2043 58.1402Z",
    fill: "#FFCC33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2043 83.9793C83.2043 87.5471 86.0965 90.4393 89.6643 90.4393C93.232 90.4393 96.1243 87.5471 96.1243 83.9793C96.1243 80.4115 93.232 77.5193 89.6643 77.5193C86.0965 77.5193 83.2043 80.4115 83.2043 83.9793Z",
    fill: "#FFCC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandb);
export default __webpack_public_path__ + "static/media/Wandb.458e898d0aa4b851e09dc9d94b154bfe.svg";
export { ForwardRef as ReactComponent };